import { Helmet } from "react-helmet-async";

const SITE = "https://hookedbyrachel.com";
const DEFAULT_TITLE = "Handmade Crochet Bags & Plushies — Hooked by Rachel";
const DEFAULT_DESC = "Colorful crochet creations handmade by Rachel — cloud-soft bags, cuddly plushies and custom orders. Little stitches, big happy feelings, hooked with love.";

export default function Seo({ title, description, path = "/", image = "/assets/og-image.jpg", noindex = false }) {
  const fullTitle = title ? `${title} — Hooked by Rachel` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE}${path === "/" ? "/" : path}`;
  const img = `${SITE}${image}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <link rel="canonical" href={url} />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Hooked by Rachel" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
